import { render, staticRenderFns } from "./prBreed.vue?vue&type=template&id=7bebb1ae&scoped=true&"
import script from "./prBreed.vue?vue&type=script&lang=js&"
export * from "./prBreed.vue?vue&type=script&lang=js&"
import style0 from "./prBreed.vue?vue&type=style&index=0&id=7bebb1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bebb1ae",
  null
  
)

export default component.exports